module.exports = __webpack_public_path__ + "img/selfieMailShare.fa7ffd6b.svg";